/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1ClassroomdisciplineIdMaterialsMaterialidMove202,
  PatchApiV1ClassroomdisciplineIdMaterialsMaterialidMove401,
  PatchApiV1ClassroomdisciplineIdMaterialsMaterialidMove404,
  PatchApiV1ClassroomdisciplineIdMaterialsMaterialidMoveMutationRequest,
  PatchApiV1ClassroomdisciplineIdMaterialsMaterialidMoveMutationResponse,
  PatchApiV1ClassroomdisciplineIdMaterialsMaterialidMovePathParams,
} from "../../types/classPlanningMaterialController/PatchApiV1ClassroomdisciplineIdMaterialsMaterialidMove.ts";
import { moveMaterialRequestViewModelSchema } from "../moveMaterialRequestViewModelSchema.ts";

export const patchApiV1ClassroomdisciplineIdMaterialsMaterialidMovePathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    materialId: z.coerce.number().int(),
  }) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdMaterialsMaterialidMovePathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const patchApiV1ClassroomdisciplineIdMaterialsMaterialidMove202Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdMaterialsMaterialidMove202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1ClassroomdisciplineIdMaterialsMaterialidMove401Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdMaterialsMaterialidMove401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const patchApiV1ClassroomdisciplineIdMaterialsMaterialidMove404Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineIdMaterialsMaterialidMove404>;

export const patchApiV1ClassroomdisciplineIdMaterialsMaterialidMoveMutationRequestSchema =
  z.lazy(
    () => moveMaterialRequestViewModelSchema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdMaterialsMaterialidMoveMutationRequest>;

export const patchApiV1ClassroomdisciplineIdMaterialsMaterialidMoveMutationResponseSchema =
  z.lazy(
    () => patchApiV1ClassroomdisciplineIdMaterialsMaterialidMove202Schema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineIdMaterialsMaterialidMoveMutationResponse>;
